var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "sector-data flex justify-space-between" }, [
      _c("div", { staticClass: "sector-name" }, [
        _vm.isAppraisal
          ? _c("span", [_vm._v("Soft Skills Appraisal Form - ")])
          : _c("span", [_vm._v("Technical Skills Appraisal Form - ")]),
        _vm._v("\n      " + _vm._s(_vm.name))
      ]),
      _c("div", { staticClass: "sector-questions" }, [
        _vm._v(
          _vm._s(_vm.activeSectorIndex + 1) + "/" + _vm._s(_vm.sectorsSize)
        )
      ])
    ]),
    _c(
      "div",
      { staticClass: "questions-container" },
      _vm._l(_vm.questions, function(question) {
        return _c("Question", {
          key: question.id,
          attrs: {
            questionId: question.id,
            text: question.text,
            order: question.ordering
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }